import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledDate = styled(FlexRow)`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[250])};
    column-gap: 8px;
`;
